import React from 'react';
import { services } from '../data/mock';

const WhatIMake = () => {
  return (
    <section id="services" className="bg-[#0B0D10] py-20 lg:py-28" aria-labelledby="what-i-build-heading">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
        {/* Section Title */}
        <div className="flex items-center gap-4 mb-10">
          <h2 id="what-i-build-heading" className="text-2xl lg:text-3xl font-semibold text-[#F2F4F7]">
            What I Build
          </h2>
          <div className="flex-1 h-px bg-white/10" aria-hidden="true" />
        </div>

        {/* Services Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {services.map((service, index) => (
            <article
              key={service.id}
              className="group bg-[#11151B]/80 border border-white/8 p-6 transition-all duration-400 hover:border-white/20 hover:bg-[#151A24]"
              style={{ animationDelay: `${index * 100}ms` }}
            >
              <h3 className="text-[#F2F4F7] font-semibold text-lg mb-3 group-hover:text-white transition-colors duration-300">
                {service.title}
              </h3>
              <p className="text-[#A6AFBD] text-sm leading-relaxed">
                {service.description}
              </p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhatIMake;
